import styled from 'styled-components'
import Mission from './Mission/Mission'
import Partnership from './Partnership/Partnership'
import SliderMain from './SliderMain/SliderMain'

import SliderNews from './SliderNews/SliderNews'
import SliderPatent from './SliderPatent/SliderPatent'
import SliderProduct from './SliderProduct/SliderProduct'
import SliderTechnology from './SliderTechnology/SliderTechnology'

function Main() {
  return (
    <Container>
      <SliderMain />
      <Mission />
      <SliderTechnology />
      <SliderProduct />
      <SliderNews />
      <SliderPatent />
      <Partnership />
      {/* <SliderMembers /> */}
    </Container>
  )
}

export default Main

// styled-components

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
`
